import { CustomElement } from '@aurelia/runtime-html';

import './op-flex-mod.css';

import './app.css';
import template from './app.html';

export default CustomElement.define({
  template,
  dependencies: [ ]
}, class {
  attached = () => {
    this.logoElement = document.getElementById('main-logo');
    window.addEventListener('scroll', this.onScroll);
    this.onScroll();
  }

  onScroll = () => {
    const y = Math.max(0, window.scrollY);
    const stop = 20;
    const translate = ((380 - y) / 1.5) + stop;
    const scale = ((380 - y) / 380) + 1;
    this.logoElement.style = `transform: translateY(${translate > stop ? translate : stop}px) scale(${scale > 1 ? scale : 1});`;
  }
});
